export default {
  en: {
    PdfTable: {
      date: {
        sp: 'Date',
        pc: 'Creation Date'
      },
      configuration: 'Configuration',
      more: 'more',
      empty: "Sorry, we couldn' find any results matching."
    }
  },
  'zh-hant': {
    PdfTable: {
      date: {
        sp: '日期',
        pc: '新增日期'
      },
      configuration: '組配',
      more: '更多',
      empty: '对不起，没有找到符合您要求的答案'
    }
  },
  ja: {
    PdfTable: {
      date: {
        sp: '作成日',
        pc: '作成日'
      },
      configuration: '構成例',
      more: '詳細',
      empty: '一致する結果は見つかりませんでした。'
    }
  },
  es: {
    PdfTable: {
      date: {
        sp: 'Fecha',
        pc: 'Fecha de creación'
      },
      configuration: 'Configuración',
      more: 'Más'
    }
  },
  'pt-br': {
    PdfTable: {
      date: {
        sp: 'Data',
        pc: 'Data de criação'
      },
      configuration: 'Configuração',
      more: 'Mais'
    }
  }
}
